import { Stack, Typography } from '@mui/material'
import { TrainIcon, useMinimalsTheme, VesselIcon } from '@tom-ui/ui'
import { CarrierType } from '@yard/app/api'
import { FC } from 'react'

type Props = {
  name: string
  visitTimestamp: string
  carrierType: CarrierType
  statusChip?: React.ReactNode
}

export const CarrierVisitOverviewCardHeader: FC<Props> = props => {
  const { name, visitTimestamp, carrierType, statusChip } = props
  const theme = useMinimalsTheme()

  return (
    <Stack display='flex' p={theme.customSpacing.s}>
      <Stack display='flex' direction='row' justifyContent='space-between'>
        {carrierType === CarrierType.Vessel && <VesselIcon fontSize='small' />}
        {carrierType === CarrierType.Train && <TrainIcon fontSize='small' />}
        {statusChip}
      </Stack>
      <Stack display='flex' direction='row' justifyContent='space-between'>
        <Typography
          variant='subtitle1'
          fontWeight={600}
          sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: 170 }}
        >
          {name}
        </Typography>

        <Typography variant='body2' color={theme.palette.text.secondary}>
          {visitTimestamp}
        </Typography>
      </Stack>
    </Stack>
  )
}
